module.exports = __webpack_public_path__ + "static/media/DSC_0032.58a8dbab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0032.jpg
// module id = 618
// module chunks = 0